<app-document-subheader></app-document-subheader>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      <div class="page-container">
        <div class="card card-light w-100">
          <div class="card-body">
            <div class="container-fluid">
              <app-bank-account-edit-card />
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (this.bankAccountId) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'BankAccount'"
          [entityId]="this.bankAccountId.toString()"
        ></app-comment-panel>
      </div>
    }
  </div>
</div>
